import React, { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functionsAsaas } from '../firebase';

const situacoes = { PENDING: 'Pendente', OVERDUE: 'Vencida', RECEIVED: 'Paga', CONFIRMED: 'Confirmada', RECEIVED_IN_CASH: 'Paga em dinheiro', REFUNDED: 'Estornada', CANCELLED: 'Cancelada' };

export default function HistoricoFaturas({ userId, todos = false, somentePendentes = false, onAtualizar }) {
  const [pagina, setPagina] = useState(0);
  const [dados, setDados] = useState({ faturas: [], temMais: false });
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');
  const [versao, setVersao] = useState(0);
  useEffect(() => { setPagina(0); setDados({ faturas: [], temMais: false }); }, [userId]);
  useEffect(() => {
    if (!userId) return undefined;
    let vigente = true;
    setCarregando(true); setErro('');
    httpsCallable(functionsAsaas, 'gerenciarFaturasCliente')({ action: 'historico', userId, offset: pagina * 10, ...(todos ? { todos: true } : {}), ...(somentePendentes ? { somentePendentes: true } : {}) })
      .then(r => { if (vigente) setDados(r.data); })
      .catch(e => { if (vigente) { setDados({ faturas: [], temMais: false }); setErro(e.message || 'Nao foi possivel consultar o historico.'); } })
      .finally(() => { if (vigente) setCarregando(false); });
    return () => { vigente = false; };
  }, [userId, pagina, versao, todos, somentePendentes]);
  return <section className="routine-surface" style={{ marginTop: 20 }}>
    <div className="routine-toolbar">
      <div className="routine-title-group"><h3 className="routine-section-title">{somentePendentes ? 'Cobranças emitidas pendentes' : 'Histórico de faturas'}</h3>
        <p className="routine-section-subtitle">{somentePendentes ? 'Cobranças que ainda não foram pagas, conforme a última situação registrada.' : 'Cobranças emitidas e última situação registrada. Faturas pendentes não representam pagamentos recebidos.'}</p></div>
      <button className="routine-btn routine-btn--soft" disabled={carregando} onClick={() => { setVersao(v => v + 1); onAtualizar?.(); }}>Atualizar histórico</button>
    </div>
    {erro && <p className="routine-callout routine-callout--warm" role="alert">{erro}</p>}
    {carregando ? <p>Carregando faturas...</p> : !erro && <>
      <div className="routine-table-wrap"><table className="routine-table">
        <thead><tr><th>Emissão</th>{todos && <th>Cliente</th>}<th>Descrição</th><th>Valor</th><th>Vencimento</th><th>Situação registrada</th><th>Fatura</th></tr></thead>
        <tbody>{dados.faturas.map(f => <tr key={f.id}>
          <td>{f.emissao?.split('-').reverse().join('/') || '---'}</td>{todos && <td>{f.nome_cliente || f.uid_matriz}</td>}<td>{f.descricao || f.id}</td>
          <td>{Number(f.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
          <td>{f.vencimento?.split('-').reverse().join('/') || '---'}</td><td>{situacoes[f.status] || f.status}</td>
          <td>{/^https:\/\//i.test(f.link || '') && f.status !== 'CANCELLED' && <a href={f.link} target="_blank" rel="noopener noreferrer">Abrir fatura</a>}</td>
        </tr>)}</tbody>
      </table></div>
      {!dados.faturas.length && <p>Nenhuma fatura salva nesta página.</p>}
    </>}
    <div className="routine-actions">
      <button className="routine-btn routine-btn--soft" disabled={carregando || pagina === 0} onClick={() => setPagina(p => p - 1)}>Anterior</button>
      <span>Página {pagina + 1}</span>
      <button className="routine-btn routine-btn--soft" disabled={carregando || !!erro || !dados.temMais} onClick={() => setPagina(p => p + 1)}>Próxima</button>
    </div>
  </section>;
}
